import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export interface IImageIntroPageConfig {
    texture: PIXI.Texture;
    position: PIXI.Point; // center
    scale: number;
}

export class ImageIntroPage extends SlideShowPage {

    constructor(config: IImageIntroPageConfig, config2?: IImageIntroPageConfig) {
        super(undefined, undefined);

        const image = new PIXI.Sprite(config.texture);
        image.anchor.set(0.5);
        image.scale.set(config.scale);
        image.position.set(config.position.x, config.position.y);
        this.addChild(image);

        if (config2) {
            const image2 = new PIXI.Sprite(config2.texture);
            image2.anchor.set(0.5);
            image.scale.set(config2.scale);
            image2.position.set(config2.position.x, config2.position.y);
            this.addChild(image2);
        }
    }
}